import React, { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Paper,
  Stepper,
  Step,
  StepLabel,
} from "@mui/material";
import {
  DoubleArrow,
  Info,
  Check,
  Person,
  Payments,
} from "@mui/icons-material";
import { themes } from "services/constants";
import { EmployeeBasicInfo } from "./EmployeeBasicInfo";
import { EmployeePersonalInfo } from "./EmployeePersonalInfo";
import { EmployeeSalaryInfo } from "./EmployeeSalaryInfo";
import { AnimatedConnector } from "components/CustomComponents/Stepper";

const steps = [
  { label: "Basic Info" },
  { label: "Personal Info" },
  { label: "Salary Info" },
];

function CustomSftCategoryStepIcon(props) {
  const { active, completed, icon } = props;

  const icons = {
    1: <Info />,
    2: <Person />,
    3: <Payments />,
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 40,
        height: 40,
        borderRadius: "50%",
        bgcolor: completed ? "#00D4AA" : active ? "#00D4AA" : "rgba(0,0,0,0.1)",
        color: "white",
      }}
    >
      {completed ? <Check /> : icons[String(icon)]}
    </Box>
  );
}

export const CreateUserEmployee = ({ onClose, reCallApi }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [getCompanyId, setGetCompanyId] = useState("");
  const [formData, setFormData] = useState({
    basicinfo: {},
    personalinfo: {},
    salaryinfo: {},
  });

  const handleNext = (value) => {
    setActiveStep(value);
  };

  const handleDataUpdate = (step, data) => {
    setFormData((prev) => ({
      ...prev,
      [step]: { ...prev[step], ...data },
    }));
  };

  const renderStepContent = (activeStep) => {
    switch (activeStep) {
      case 0:
        return (
          <EmployeeBasicInfo
            data={formData?.basicinfo}
            handleNext={handleNext}
            onUpdate={(data) => handleDataUpdate("basicinfo", data)}
            reCallApi={reCallApi}
            onClose={onClose}
            setGetCompanyId={setGetCompanyId}
          />
        );
      case 1:
        return (
          <EmployeePersonalInfo
            data={formData?.personalinfo}
            handleNext={handleNext}
            onUpdate={(data) => handleDataUpdate("personalinfo", data)}
            reCallApi={reCallApi}
            onClose={onClose}
            basicinfo={formData?.basicinfo}
          />
        );
      case 2:
        return (
          <EmployeeSalaryInfo
            data={formData?.salaryinfo}
            reCallApi={reCallApi}
            onUpdate={(data) => handleDataUpdate("salaryinfo", data)}
            onClose={onClose}
            getCompanyId={getCompanyId}
            isAddScreen={true}
          />
        );
      default:
        return "Unknown step";
    }
  };

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          borderBottom: `1px solid ${themes?.miliedLightGray}`,
          borderRadius: 0,
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          sx={{ padding: 1, backgroundColor: themes?.primary }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              borderRadius: "50%",
            }}
          >
            <Box sx={{ ml: 1 }}>
              <IconButton
                onClick={onClose}
                sx={{
                  color: themes?.grayColor,
                  "&:hover": {
                    backgroundColor: themes?.whiteColor,
                  },
                }}
              >
                <DoubleArrow />
              </IconButton>
            </Box>
          </Box>

          <Box sx={{ ml: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Create Employee Information
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Create the information of the employee.
            </Typography>
          </Box>
        </Box>
      </Paper>

      <Box sx={{ flexGrow: 1, overflow: "auto" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={{ mt: 3 }}>
            <Stepper
              activeStep={activeStep}
              alternativeLabel
              connector={<AnimatedConnector />}
              sx={{ mb: 2 }}
            >
              {steps.map((step, index) => (
                <Step key={step.label}>
                  <StepLabel
                    StepIconComponent={CustomSftCategoryStepIcon}
                    sx={{
                      "& .MuiStepLabel-label.Mui-active": {
                        color: "#00D4AA",
                        fontWeight: "bold",
                      },
                      "& .MuiStepLabel-label.Mui-completed": {
                        color: "#00D4AA",
                      },
                    }}
                  >
                    {step.label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </Box>
          <Box
            sx={{
              borderBottom: `1px solid ${themes?.miliedLightGray}`,
              borderRadius: 0,
            }}
          ></Box>
          <Box>{renderStepContent(activeStep)}</Box>
        </Box>
      </Box>
    </Box>
  );
};
